import useGetKeyByActivity from './druid/providers/ActivityKeyer/useGetKeyByActivity';

export default useGetKeyByActivity;
